/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConsultantViewModel } from './ConsultantViewModel';
import {
    ConsultantViewModelFromJSON,
    ConsultantViewModelFromJSONTyped,
    ConsultantViewModelToJSON,
} from './ConsultantViewModel';

/**
 * 
 * @export
 * @interface UpsertConsultantCommand
 */
export interface UpsertConsultantCommand {
    /**
     * 
     * @type {number}
     * @memberof UpsertConsultantCommand
     */
    proposalId: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertConsultantCommand
     */
    productId: number;
    /**
     * 
     * @type {ConsultantViewModel}
     * @memberof UpsertConsultantCommand
     */
    consultant: ConsultantViewModel;
}

/**
 * Check if a given object implements the UpsertConsultantCommand interface.
 */
export function instanceOfUpsertConsultantCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "consultant" in value;

    return isInstance;
}

export function UpsertConsultantCommandFromJSON(json: any): UpsertConsultantCommand {
    return UpsertConsultantCommandFromJSONTyped(json, false);
}

export function UpsertConsultantCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertConsultantCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'productId': json['ProductId'],
        'consultant': ConsultantViewModelFromJSON(json['Consultant']),
    };
}

export function UpsertConsultantCommandToJSON(value?: UpsertConsultantCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'ProductId': value.productId,
        'Consultant': ConsultantViewModelToJSON(value.consultant),
    };
}

